import Vue from "vue";
import Vuex from "vuex";
import layout from "./modules/layout";
import settings from "./modules/settings";
import workers from "./modules/workers";
import agencies from "./modules/agencies";
import bookings from "@/store/modules/bookings/bookings";
import global from "@/store/modules/global/global";
import applications from "@/store/modules/applications";
import dashboard from "@/store/modules/dashboard";
import data from "@/store/modules/data";
import auth from "@/store/modules/auth";
import users from "@/store/modules/users";
import organisations from "@/store/modules/organisations";
import addresses from "@/store/modules/addresses";
import reports from "@/store/modules/reports";
import conversations from "@/store/modules/conversations";
import offers from "@/store/modules/offers";
import referee from "@/store/modules/referee";
import references from "@/store/modules/references";
import talentPools from "@/store/modules/talentPools";
import microsites from "@/store/modules/microsites";
import exports from "@/store/modules/exports";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";
const isNotTestingEnv = process.env.NODE_ENV !== "test";

let store;
if (isNotTestingEnv) {
  store = new Vuex.Store({
    strict: debug,
    modules: {
      settings,
      layout,
      workers,
      agencies,
      bookings,
      global,
      applications,
      dashboard,
      data,
      auth,
      users,
      organisations,
      addresses,
      reports,
      conversations,
      offers,
      referee,
      references,
      talentPools,
      microsites,
      exports
    }
  });
}

export default store;
